module.exports = __webpack_public_path__ + "assets/img/title.1ebe1503.png";